import { render, staticRenderFns } from "./AccessibilityView.vue?vue&type=template&id=0f5c0398&"
import script from "./AccessibilityView.vue?vue&type=script&lang=js&"
export * from "./AccessibilityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports